<template>
  <q-page class="main">
    <common-form :action="$route('custom-rule.update', {custom_richtlijn: rule.id})" is-update>
      <q-card class="page-card">
        <q-card-section class="page-card__main-content">
          <rule-form
              :rule="rule"
              :phases="phases"
              :categories="categories"
              :subcategories="subcategories"
              :themes="themes"
              :ruleVersion="ruleVersion"
              :editableCategories="editableCategories"
              isTypeless
              isMapless />
          <input type="hidden" name="project_id" :value="project.id" />
        </q-card-section>
        <q-separator />
        <q-card-actions align="between" class="q-pa-md">
          <warning-button label="Verwijder" color="negative" @click="removeCustomRule" />
          <accent-button label="Opslaan" type="submit" />
        </q-card-actions>
      </q-card>
      <sticky-top-bar />
    </common-form>
  </q-page>
</template>

<script>
import RuleForm from '~HIOR/pages/rule/RuleForm'
import ChipList from '~HIOR/components/lists/ChipList'
import DocumentList from '~HIOR/components/lists/DocumentList'

export default {
  props: {
    rule: {
      type: Object,
      default: null,
    },
    ruleVersion: {
      type: Object,
      default: null,
    },
    phases: {
      type: Object,
      default: null,
    },
    categories: {
      type: Object,
      default: null,
    },
    editableCategories: {
      type: Array,
      default: null
    },
    subcategories: {
      type: Object,
      default: null,
    },
    themes: {
      type: Array,
      default: null,
    },
    project: {
      type: Object,
      default: null,
    },
  },
  components: {
    ChipList,
    DocumentList,
    RuleForm,
  },
  methods: {
    async removeCustomRule () {
      if (await this.$confirm({ title: 'Weet u zeker dat u deze richtlijn wilt verwijderen?' })) {
        try {
          await axios.delete(this.$route('rule.destroy', { rule_id: this.ruleVersion.rule_id }))
          this.$toast('success', 'De richtlijn is verwijderd')
          this.$goto('project.rule.index', {
            project_id: this.project.id,
            phase_id: this.phase.id,
          })
        } catch (e) {
          console.error(e)
          this.$toast('error', 'De richtlijn kon niet worden verwijderd')
        }
      }
    },
  },
}
</script>
